import {
  BMComponentsType,
  BMNewIndicator,
  BMText,
  BMTooltip,
  useBMTheme,
} from "@traveloka/district-bloom";
import { StyleSheet } from "react-native";

import BMView from "../View/BMView";
import { appendTestId } from "../../utils";
import type { BMMultiLoginTooltipProps } from "./types";

export default function BMMultiLoginTooltip({
  children,
  title,
  description,
  show,
  position = "bottom-left",
  width = 236,
  showCloseButton = true,
  useOverlay = false,
  onCloseClick,
  hideIndicator = false,
  centerIndicator = false,
  indicatorStyle,
  multiLoginEnabled,
  testID,
}: BMMultiLoginTooltipProps) {
  const { BMComponents } = useBMTheme();
  if (multiLoginEnabled === false) {
    return <>{children}</>;
  }
  return (
    <BMTooltip
      position={position}
      width={width}
      show={show}
      showCloseButton={showCloseButton}
      useOverlay={useOverlay}
      onCloseClick={onCloseClick}
      testID={appendTestId(testID, "tooltip")}
      content={
        <BMView spacing="md">
          <BMText variant="uiLarge" ink="BMStyleTextInkPrimaryInvert">
            {title}
          </BMText>
          <BMText variant="paragraphSmall" ink="BMStyleTextInkPrimaryInvert">
            {description}
          </BMText>
        </BMView>
      }
    >
      <BMView style={styles.anchor}>
        {children}
        {show && !hideIndicator && (
          <BMView
            style={[
              styles.indicatorBase,
              !indicatorStyle && !centerIndicator && styles.indicatorDefault,
              !indicatorStyle && centerIndicator && styles.indicatorCentered,
              indicatorStyle,
            ]}
            align={!indicatorStyle && centerIndicator ? "center" : undefined}
            justify={!indicatorStyle && centerIndicator ? "center" : undefined}
            pointerEvents="none"
          >
            <BMNewIndicator
              color={
                BMComponents.BMStyleTextInkPrice as unknown as BMComponentsType
              }
              testID={appendTestId(testID, "indicator")}
            />
          </BMView>
        )}
      </BMView>
    </BMTooltip>
  );
}

const styles = StyleSheet.create({
  anchor: {
    position: "relative",
  },
  indicatorBase: {
    position: "absolute",
    zIndex: 10,
  },
  indicatorDefault: {
    top: -4,
    left: -4,
  },
  indicatorCentered: {
    ...StyleSheet.absoluteFillObject,
  },
});
